import { useEffect, useRef } from "react";

import * as S from "./styles";

import { ReactComponent as Plus } from "assets/plus-cross.svg";

export type AddMapOption = {
  id: string;
  label: string;
};

type Props = {
  options: AddMapOption[];
  showOptions?: boolean;
  onClose?: () => void;
  onClick?: () => void;
  onOptionClick: (id: string) => void;
};

function MapAddButton({
  options,
  showOptions = false,
  onClick = () => {},
  onClose = () => {},
  onOptionClick,
}: Props) {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <S.Wrapper ref={wrapperRef}>
      {showOptions && (
        <S.OptionsContainer>
          {options.map((option) => (
            <li
              key={option.id}
              onClick={() => {
                onOptionClick(option.id);
                onClose();
              }}
            >
              {option.label}
            </li>
          ))}
        </S.OptionsContainer>
      )}

      <S.Button onClick={onClick} isActive={showOptions}>
        <Plus />
      </S.Button>
    </S.Wrapper>
  );
}

export { MapAddButton };
